import type { App } from "vue"
import type { ModuleDefinition, ModuleOptions } from "@core/types/module"

const companySpaceModule: ModuleDefinition = {
    name: "company-space",

    install(_app: App, _options: ModuleOptions): void {
        // Initialisation du module
    },
}

export default companySpaceModule
